import useCropSeasonServiceApi from 'hooks/useCropSeasonServiceApi';
import {
  CROP_SEASONS_LIST_V2,
  CROP_SEASONS_LIST_V2_BY_ORG,
  CROP_SEASONS_CONDENSED_V2,
  CROP_SEASONS_CONDENSED_V2_BY_ORG
} from 'constants/cropSeasonServiceV2Flags';

const useCropSeasonsListApi = (isCondensed: boolean) => {
  const listSeasonsApi = useCropSeasonServiceApi(
    'cropseasons',
    CROP_SEASONS_LIST_V2,
    CROP_SEASONS_LIST_V2_BY_ORG
  );
  const condensedSeasonsApi = useCropSeasonServiceApi(
    'cropseasons/condensed',
    CROP_SEASONS_CONDENSED_V2,
    CROP_SEASONS_CONDENSED_V2_BY_ORG
  );

  return isCondensed ? condensedSeasonsApi : listSeasonsApi;
};

export default useCropSeasonsListApi;
